export default "__VITE_PUBLIC_ASSET__8e00b435__"